export default __webpack_public_path__ + "static/terrible-470044cbec03e4868c39a4dc24988349.png";